import api from './client';
import { getOAuthCallbackOrigin } from './client';

// Auth API
// Response format: { access_token, refresh_token, token_type, expires_in, user }
export const authAPI = {
  googleLogin: () => api.get('/auth/google/login', {
    params: { origin: getOAuthCallbackOrigin() },
  }),
  googleExchange: (code) => api.post('/auth/google/exchange', { code }),
  refresh: (refreshToken) => api.post('/auth/refresh', { refresh_token: refreshToken }),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
  updateEntity: (entity) => api.put(`/auth/entity?entity=${entity}`),
};
